import { useSelector } from "react-redux";
import SavedItemsProductTileList from "../../../presentational/common/SavedItemsProductTileList";
import { getSort, getSortOrder } from "../../../../state/selectors";

const SavedItemsProductTileListContainer = props => {
  const sort = useSelector(getSort);
  const sortOrder = useSelector(getSortOrder);

  return <SavedItemsProductTileList {...{ ...props, sort, sortOrder }} />;
};

export default SavedItemsProductTileListContainer;
